import { takeLatest, put, call, all } from "redux-saga/effects";
import {
  Types,
  CycloAttitudeType,
  IRequestCycleAttitudesLoadAction,
  IRequestCycleAttitudesAddAction,
  IRequestCycleAttitudesDelAction,
  ISuccessCycleAttitudesLoadAction,
  ISuccessCycleAttitudesAddAction,
  ISuccessCycleAttitudesDelAction
} from "../ducks/cycle/attitude/types";
import api from "~/services/api";

const apiCallGet = (idCiclo: number) => {
  return api
    .get(`/ciclos/${idCiclo}/atitudes`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response;
    });
};

const apiCallAdd = (payload: IRequestCycleAttitudesAddAction["payload"]) => {
  let body: any = {
    idAtitude: payload.idAtitude,
  }

  if(payload.ordem) body.ordem = payload.ordem

  return api
    .post(`/ciclos/${payload.idCiclo}/atitudes`, {
      ...body
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response;
    });
};

const apiCallDel = (payload: IRequestCycleAttitudesDelAction["payload"]) => {
  return api
    .delete(`/ciclos/${payload.idCiclo}/atitudes/${payload.idCicloAtitude}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response;
    });
};


function* load(action: IRequestCycleAttitudesLoadAction) {
  try {
    let items: any = yield call(apiCallGet, action.idCiclo);
    yield put({
      type: Types.SUCCESS_CYCLE_ATTITUDES_LOAD,
      payload: items
    } as ISuccessCycleAttitudesLoadAction);
  } catch (error) {
    const message = error !== undefined ? error.data.message : 'Não foi possível carregar as atitudes'
    yield put({
      type: Types.FAILURE_CYCLE_ATTITUDES_LOAD,
      message
    });
  }
}

function* add(action: IRequestCycleAttitudesAddAction) {
  try {
    const idCicloAtitude: any = yield call(apiCallAdd, action.payload);
    yield put({
      type: Types.SUCCESS_CYCLE_ATTITUDES_ADD,
      payload: { ...action.payload, ...idCicloAtitude }
    } as ISuccessCycleAttitudesAddAction);
  } catch (error) {
    const message = error !== undefined ? error.data.message : 'Não foi possível inserir a atitude ao ciclo'
    yield put({
      type: Types.FAILURE_CYCLE_ATTITUDES_ADD,
      message
    });
  }
}

function* del(action: IRequestCycleAttitudesDelAction) {
  try {
    yield call(apiCallDel, action.payload);
    yield put({
      type: Types.SUCCESS_CYCLE_ATTITUDES_DEL,
      idCicloAtitude: action.payload.idCicloAtitude
    } as ISuccessCycleAttitudesDelAction);
  } catch (error) {
    const message = error !== undefined ? error.data.message : 'Não foi possível excluir a atitude do ciclo'
    yield put({
      type: Types.FAILURE_CYCLE_ATTITUDES_DEL,
      message
    });
  }
}

export default function* companiesRoot() {
  yield all([
    yield takeLatest(Types.REQUEST_CYCLE_ATTITUDES_LOAD, load),
    yield takeLatest(Types.REQUEST_CYCLE_ATTITUDES_ADD, add),
    yield takeLatest(Types.REQUEST_CYCLE_ATTITUDES_DEL, del),
  ]);
}
